import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusCaptured = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Capturé</title>
        <path
          d="M19.7188 4.91363L6.54883 17.6036L6.17883 17.9536C5.88883 18.2336 5.55883 18.4136 5.15883 18.4036C4.75883 18.4036 4.42883 18.2836 4.16883 18.0236L2.05883 16.0036C1.50883 15.4836 0.95883 14.9536 0.40883 14.4236C-0.13117 13.9136 -0.13117 13.1336 0.37883 12.6236C0.91883 12.0736 1.72883 12.0236 2.29883 12.5336C3.18883 13.3436 4.05883 14.1736 4.91883 15.0136C5.09883 15.1836 5.18883 15.1636 5.34883 15.0136L6.14883 14.2436L17.7588 3.05363C18.4488 2.39363 19.4988 2.53363 19.9688 3.27363C20.3788 3.83363 20.2088 4.44363 19.7188 4.91363Z"
          fill="#F7A614"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusCaptured;
